<template id="mapPoiFrmTmpl">
	<v-dialog v-model="dialogPoiEditIsOpen" fullscreen hide-overlay transition="dialog-bottom-transition">
		<v-card v-if="poiitem != null">
			<v-toolbar color="primary" dark>
				<v-btn icon dark v-on:click="closeEditPoiDialog()">
					<v-icon>close</v-icon>
				</v-btn>
				<v-toolbar-title v-if="poiitem.poi_id != null">{{$t('lbl.editPoi')}}</v-toolbar-title>
				<v-toolbar-title v-else>{{$t('lbl.newPoi')}}</v-toolbar-title>
			</v-toolbar>
			<v-form ref="poiFrm" v-model="validPoiFrm" lazy-validation>
				<v-card>
					<v-card-subtitle>{{$t('lbl.poiInfo')}}</v-card-subtitle>

					<v-card-text>
						<v-row no-gutters>
							<v-col cols="12">
								{{$t('lbl.poiId')}}: {{ poiitem.poi_id }}
							</v-col>
						</v-row>	
						<v-row no-gutters>
							<v-col cols="12">
								{{$t('lbl.map')}}: {{ mapitem.map_name }}
							</v-col>
						</v-row>
						<v-row no-gutters>
							<v-col cols="12">
								<v-switch v-model="poiitem.flags.active" :label="$t('lbl.active')"></v-switch>
							</v-col>
						</v-row>	
					</v-card-text>

					<v-card-subtitle>{{$t('lbl.sensorConfiguration')}}</v-card-subtitle>
					
					<div v-for="(thing, index) in poiitem.things" v-bind:key="index">
						<v-card-text>
							<v-row no-gutters>
								<v-col cols="12" md="6">
									<v-text-field v-model="thing.thing_name" :label="$t('lbl.poiThingName')" :rules="poiThingNameRules"></v-text-field>
								</v-col>
								<v-col cols="12" md="6">
									<v-text-field v-model="thing.thing_id" :label="$t('lbl.poiThingId')" :rules="poiThingIdRules"></v-text-field>
								</v-col>
							</v-row>
							<v-row no-gutters>
								<v-col cols="12" md="6">
									<v-text-field v-model="thing.service_id" :label="$t('lbl.poiThingServiceId')" :rules="poiThingServiceIdRules"></v-text-field>
								</v-col>
								<v-col cols="12" md="6">
									<v-text-field v-model="thing.type" :label="$t('lbl.poiThingType')" :rules="poiThingTypeRules"></v-text-field>
								</v-col>
							</v-row>
							<v-row no-gutters>
								<v-col cols="12">
									<v-text-field v-model="thing.thing_link" :label="$t('lbl.poiThingLink')"></v-text-field>
								</v-col>
							</v-row>
							
							
						</v-card-text>
					</div>
				
					<div v-if="mapitem != null && (mapitem.map_asset_type == 'threejs' || mapitem.map_asset_type == 'render3d_basic' || mapitem.map_asset_type == 'render3d_pro')">
						<v-card-subtitle>{{$t('lbl.graphicInfo')}}</v-card-subtitle>
						
						<v-card-text>
							<v-row no-gutters>
								<v-col cols="12" md="4">
									<v-select v-model="poiitem.background_image" :items="poiBkgImageItems" :label="$t('lbl.poiBackgroundImage')"></v-select>
								</v-col>
							</v-row>
							<v-row no-gutters v-if="helperPositionPhrase != null && !isEmptyString(helperPositionPhrase)">
								<v-col cols="12">
									<strong>{{this.helperPositionPhrase}}</strong>
								</v-col>
							</v-row>
							<v-row no-gutters>
								<v-col cols="12" md="4">
									<v-text-field type="number" v-model.number="poiitem.transform.position.x" :label="$t('lbl.poiPosX')"></v-text-field>
								</v-col>
								<v-col cols="12" md="4">
									<v-text-field type="number" v-model.number="poiitem.transform.position.y" :label="$t('lbl.poiPosY')"></v-text-field>
								</v-col>
								<v-col cols="12" md="4">
									<v-text-field type="number" v-model.number="poiitem.transform.position.z" :label="$t('lbl.poiPosZ')"></v-text-field>
								</v-col>
							</v-row>
							<v-row no-gutters>
								<v-col cols="12" md="4">
									<v-text-field type="number" v-model.number="poiitem.transform.rotation.x" :label="$t('lbl.poiRotationX')"></v-text-field>
								</v-col>
								<v-col cols="12" md="4">
									<v-text-field type="number" v-model.number="poiitem.transform.rotation.y" :label="$t('lbl.poiRotationY')"></v-text-field>
								</v-col>
								<v-col cols="12" md="4">
									<v-text-field type="number" v-model.number="poiitem.transform.rotation.z" :label="$t('lbl.poiRotationZ')"></v-text-field>
								</v-col>
							</v-row>
							<v-row no-gutters>
								<v-col cols="12" md="4">
									<v-text-field type="number" v-model.number="poiitem.transform.scale.x" :label="$t('lbl.poiScaleX')"></v-text-field>
								</v-col>
								<v-col cols="12" md="4">
									<v-text-field type="number" v-model.number="poiitem.transform.scale.y" :label="$t('lbl.poiScaleY')"></v-text-field>
								</v-col>
								<v-col cols="12" md="4">
									<v-text-field type="number" v-model.number="poiitem.transform.scale.z" :label="$t('lbl.poiScaleZ')"></v-text-field>
								</v-col>
							</v-row>
						</v-card-text>
					</div>

					<div v-if="mapitem != null && mapitem.map_asset_type == 'image'">
						<v-card-subtitle>{{$t('lbl.graphicInfo')}}</v-card-subtitle>
						
						<v-card-text>
							<v-row no-gutters>
								<v-col cols="12" md="4">
									<v-select v-model="poiitem.background_image" :items="poiBkgImageItems" :label="$t('lbl.poiBackgroundImage')"></v-select>
								</v-col>
							</v-row>
							<v-row no-gutters v-if="helperPositionPhrase != null && !isEmptyString(helperPositionPhrase)">
								<v-col cols="12">
									<strong>{{this.helperPositionPhrase}}</strong>
								</v-col>
							</v-row>
							<v-row no-gutters>
								<v-col cols="12" md="6">
									<v-text-field type="number" v-model.number="poiitem.transform.position.x" :label="$t('lbl.poiPosX')"></v-text-field>
								</v-col>
								<v-col cols="12" md="6">
									<v-text-field type="number" v-model.number="poiitem.transform.position.y" :label="$t('lbl.poiPosY')"></v-text-field>
								</v-col>
							</v-row>
						</v-card-text>
					</div>	  

					<v-card-actions>
						<v-flex xs12>
							<v-btn class="button-main ma-1" v-on:click="doSavePoi()"><v-icon left dark>cloud_upload</v-icon>{{ $t('btn.save')}}</v-btn>
						</v-flex>
					</v-card-actions>

					<v-card-subtitle>{{$t('lbl.middleware')}}</v-card-subtitle>

					<v-card-text v-if="mapitem != null && mapitem.map_asset_type != null && (mapitem.map_asset_type == 'render3d_pro' || mapitem.map_asset_type == 'render3d_basic')">
						<v-row no-gutters>
							<v-col cols="12">
								<strong>{{$t('lbl.middlewareShin3dCalls')}}</strong>
							</v-col>
						</v-row>
						<v-row no-gutters>
							<v-col cols="12">
								<v-btn v-on:click="gotoRender3dGatewayPoiDetails()" >{{$t('btn.gatewayPoiDetails')}}</v-btn>
								<v-btn v-on:click="gotoGatewayPoiChart()" >{{$t('btn.gatewayPoiChart')}}</v-btn>
							</v-col>
						</v-row>	
					</v-card-text>

					<v-card-text>
						<v-row no-gutters>
							<v-col cols="12">
								<strong>{{$t('lbl.middlewareCommonCalls')}}</strong>
							</v-col>
						</v-row>
						<v-row no-gutters>
							<v-col cols="12">
								<v-btn class="button-secondary ma-1" v-on:click="gotoGeneralGatewayPoiDetails()" >{{$t('btn.gatewayPoiDetails')}}</v-btn>
								<v-btn class="button-secondary ma-1" v-on:click="gotoGeneralGatewayPoiStats()" >{{$t('btn.gatewayPoiStats')}}</v-btn>
							</v-col>
						</v-row>	
					</v-card-text>
				</v-card>
			</v-form>	
		</v-card>
	</v-dialog>	
</template>
<script>
import i18n from '@/i18n';
import {events} from '@/event-bus.js';
import constants from '@/ctConstants.js';

export default {
    i18n,
     data: () => ({
		dialogPoiEditIsOpen: false,
		poiBkgImageItems:[],
		validPoiFrm: false,
		helperPositionPhrase: '',
		/*
		poiBackgroundImageRules: [
			v => !!v || i18n.t('err.fieldNotValid'),
			v => v.length > 0 || i18n.t('err.fieldNotValid')
		],
		*/
		poiThingServiceIdRules: [
			v => !!v || i18n.t('err.fieldNotValid'),
			v => v.length > 0 || i18n.t('err.fieldNotValid')
		],
		poiThingIdRules: [
			v => !!v || i18n.t('err.fieldNotValid'),
			v => v.length > 0 || i18n.t('err.fieldNotValid')
		],
		poiThingNameRules: [
			v => !!v || i18n.t('err.fieldNotValid'),
			v => v.length > 0 || i18n.t('err.fieldNotValid')
		],
		poiThingTypeRules: [
			v => !!v || i18n.t('err.fieldNotValid'),
			v => v.length > 0 || i18n.t('err.fieldNotValid')
		]
	}),
	props: ['orgid', 'siteid', 'mapitem', 'poiitem'],
	mounted() {
		this.loadPoiBkgImageItems();
		this.loadPoiShapeItems();
		events.$on(constants.EVENT_CHANGE_LOCALE, () => {
			this.loadPoiBkgImageItems();
			this.loadPoiShapeItems();
		});

		//=== HELP PHRASE
		this.helperPositionPhrase = '';
		if(this.mapitem != null && this.mapitem.map_asset_type != null && this.mapitem.map_asset_type == 'threejs')
		{
			try{
				var half = parseInt(constants.THREEJS_FLOOR_GRID_SIZE) / 2;
				this.helperPositionPhrase = i18n.t('lbl.helperPhrasePositionPoiThreeJs', { floorSize: constants.THREEJS_FLOOR_GRID_SIZE});
				this.helperPositionPhrase += ' (-' + half + ' / ' + '+' + half + ')';
			} catch(err) {
				this.helperPositionPhrase = '';
			}
		} 
		else if(this.mapitem != null && this.mapitem.map_asset_type != null && this.mapitem.map_asset_type == 'render3d_basic')
		{
			this.helperPositionPhrase = i18n.t('lbl.helperPhrasePositionPoi3d');
		}
		else if(this.mapitem != null && this.mapitem.map_asset_type != null && this.mapitem.map_asset_type == 'image')
		{
			this.helperPositionPhrase = i18n.t('lbl.helperPhrasePositionPoiRenderingImage');
		}

		
	},
	destroyed() {
		events.$off(constants.EVENT_CHANGE_LOCALE);
	},
	methods: {
		loadPoiBkgImageItems()
		{
			//this.poiBkgImageItems = [
			//	{value: "22", text: "Controllo Accessi"},
			//	{value: "23", text: "Incendi"},
			//	{value: "24", text: "Vibrazioni"},
			//	{value: "28", text: "Movimenti"},
			//	{value: "30", text: "Liquido"},
			//]	
			this.$root.genericGetCallEngine(constants.ENDPOINT_GATEWAY_BKG_IMG_LIST, this.callbackLoadPoiBkgImageItems, 'err.loadingPoisImgs');
		}, 
		callbackLoadPoiBkgImageItems(responseData) 
		{
			if(!this.isEmptyObj(responseData))
			{
				
				this.poiBkgImageItems = responseData;
			}
			else 
			{
				this.$root.setDialogMsg(i18n.t("err.loadingPoisImgs"));
			}	
		},
		loadPoiShapeItems()
		{
			this.poiShapeItems = this.getPoiShapeItems();
		}, 
		doSavePoi()
		{
			if (this.$refs.poiFrm.validate()) {
				if(!this.isEmptyObj(this.poiitem)){
					var endpoint2go = constants.ENDPOINT_GUI_ADMIN_ORGANIZATIONS + '/'+ this.orgid + '/sites/'+ this.siteid +'/maps/' + this.mapitem.sitemap_id +'/pois';
					
					var obj2send = null;
					if(!this.isEmptyString(this.poiitem.poi_id) )
					{
						endpoint2go += '/' +this.poiitem.poi_id;
						//alert("CHIAMO PATCH PERCHE EDIT");
						obj2send = this.poiitem;
						this.$root.genericPatchAuthenticatedCallEngine(endpoint2go, obj2send, this.callbackDoSavePoi, 'err.savingPoi');
					} 
					else 
					{
						//alert("CHIAMO POST PERCHE CREATE");
						obj2send = this.poiitem;
						this.$root.genericPostAuthenticatedCallEngine(endpoint2go, obj2send, this.callbackDoSavePoi, 'err.savingPoi');
					}
					
					
				} else {
					this.$root.setDialogMsg(i18n.t('err.poiSelectedNotValid'));
				}
			}					
		}, 
		callbackDoSavePoi(responseData) 
		{
			if(!this.isEmptyObj(responseData))
			{
				this.$root.setDialogMsg(i18n.t('msg.saveok'));
				this.dialogPoiEditIsOpen = false;
				events.$emit('reloadPoiList');
			}
			else 
			{
				this.$root.setDialogMsg(i18n.t("err.savingPoi"));
			}								
		},
		gotoRender3dGatewayPoiDetails()
		{
			if(this.isEmptyString(this.orgid))  
			{
				this.$root.setDialogMsg(i18n.t("err.orgSelectedNotValid"));
			} 
			else if(this.isEmptyString(this.siteid))  
			{
				this.$root.setDialogMsg(i18n.t("err.siteSelectedNotValid"));
			}
			else if(this.isEmptyObj(this.mapitem) || (!this.isEmptyObj(this.mapitem) && this.isEmptyString(this.mapitem.sitemap_id)))  
			{
				this.$root.setDialogMsg(i18n.t('err.mapSelectedNotValid'));
			}
			else if(this.isEmptyObj(this.poiitem) || (!this.isEmptyObj(this.poiitem) && this.isEmptyString(this.poiitem.poi_id)))  
			{
				this.$root.setDialogMsg(i18n.t('err.poiSelectedNotValid'));
			}
			else
			{
				var url2go = constants.ENDPOINT_GATEWAY_POI_S3D_DETAILS;
				url2go += "?org=" + this.orgid;
				url2go += "&site=" + this.siteid;
				url2go += "&map=" + this.mapitem.sitemap_id;
				url2go += "&poiIdReq=" + this.poiitem.poi_id;
				url2go += "&accessToken=" + this.getUserAccessToken();
				console.log(url2go);
				window.open(url2go);
			}
		},
		gotoGeneralGatewayPoiDetails()
		{
			if(this.isEmptyString(this.orgid))  
			{
				this.$root.setDialogMsg(i18n.t("err.orgSelectedNotValid"));
			} 
			else if(this.isEmptyString(this.siteid))  
			{
				this.$root.setDialogMsg(i18n.t("err.siteSelectedNotValid"));
			}
			else if(this.isEmptyObj(this.mapitem) || (!this.isEmptyObj(this.mapitem) && this.isEmptyString(this.mapitem.sitemap_id)))  
			{
				this.$root.setDialogMsg(i18n.t('err.mapSelectedNotValid'));
			}
			else if(this.isEmptyObj(this.poiitem) || (!this.isEmptyObj(this.poiitem) && this.isEmptyString(this.poiitem.poi_id)))  
			{
				this.$root.setDialogMsg(i18n.t('err.poiSelectedNotValid'));
			}
			else
			{
				var url2go = constants.ENDPOINT_GATEWAY_POI_DETAILS;
				url2go += "?org=" + this.orgid;
				url2go += "&site=" + this.siteid;
				url2go += "&map=" + this.mapitem.sitemap_id;
				url2go += "&poi=" + this.poiitem.poi_id;
				url2go += "&accessToken=" + this.getUserAccessToken();
				console.log(url2go);
				window.open(url2go);
			}
		},
		gotoGatewayPoiChart()
		{
			if(this.isEmptyString(this.orgid))  
			{
				this.$root.setDialogMsg(i18n.t("err.orgSelectedNotValid"));
			} 
			else if(this.isEmptyString(this.siteid))  
			{
				this.$root.setDialogMsg(i18n.t("err.siteSelectedNotValid"));
			}
			else if(this.isEmptyObj(this.mapitem) || (!this.isEmptyObj(this.mapitem) && this.isEmptyString(this.mapitem.sitemap_id)))  
			{
				this.$root.setDialogMsg(i18n.t('err.mapSelectedNotValid'));
			}
			else if(this.isEmptyObj(this.poiitem) || (!this.isEmptyObj(this.poiitem) && this.isEmptyString(this.poiitem.poi_id)))  
			{
				this.$root.setDialogMsg(i18n.t('err.poiSelectedNotValid'));
			}
			else
			{
				var url2go = constants.ENDPOINT_GATEWAY_POI_CHART;
				url2go += "?org=" + this.orgid;
				url2go += "&site=" + this.siteid;
				url2go += "&map=" + this.mapitem.sitemap_id;
				url2go += "&poiIdReq=" + this.poiitem.poi_id;
				url2go += "&accessToken=" + this.getUserAccessToken();
				console.log(url2go);
				window.open(url2go);
			}
		},
		gotoGeneralGatewayPoiStats(){
			if(this.isEmptyString(this.orgid))  
			{
				this.$root.setDialogMsg(i18n.t("err.orgSelectedNotValid"));
			} 
			else if(this.isEmptyString(this.siteid))  
			{
				this.$root.setDialogMsg(i18n.t("err.siteSelectedNotValid"));
			}
			else if(this.isEmptyObj(this.mapitem) || (!this.isEmptyObj(this.mapitem) && this.isEmptyString(this.mapitem.sitemap_id)))  
			{
				this.$root.setDialogMsg(i18n.t('err.mapSelectedNotValid'));
			}
			else if(this.isEmptyObj(this.poiitem) || (!this.isEmptyObj(this.poiitem) && this.isEmptyString(this.poiitem.poi_id)))  
			{
				this.$root.setDialogMsg(i18n.t('err.poiSelectedNotValid'));
			}
			else
			{
				var url2go = constants.ENDPOINT_GATEWAY_POI_STATS;
				url2go += "?org=" + this.orgid;
				url2go += "&site=" + this.siteid;
				url2go += "&map=" + this.mapitem.sitemap_id;
				url2go += "&poi=" + this.poiitem.poi_id;
				url2go += "&accessToken=" + this.getUserAccessToken();
				console.log(url2go);
				window.open(url2go);
			}
		},
		closeEditPoiDialog() 
		{	
			this.dialogPoiEditIsOpen = false;
		},
		openEditPoiDialog() 
		{	
			this.dialogPoiEditIsOpen = true;
		},
	}
}
</script>